module.exports = __webpack_public_path__ + "img/flowers.796cd2b3.png";